import 'react-phone-input-2/lib/high-res.css';

import { useField, useFormikContext } from 'formik';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PhoneInput, { CountryData, PhoneInputProps } from 'react-phone-input-2';

import { PHONE_INPUT_PLACEHOLDERS } from '../../declarations/constants/phone';
import {
  ErrorMessageStyled,
  InputLabelStyled,
  StarStyled,
} from '../FormikInput/FormikInput.styled';
import { InputWrapperStyled } from './FormikPhoneInput.styled';

type FormikPhoneInputPropsT = {
  name: string;
  label?: string | React.ReactNode;
  isRequired?: boolean;
} & PhoneInputProps;

const FormikPhoneInput: React.FC<FormikPhoneInputPropsT> = ({
  name,
  label,
  isRequired = true,
  preferredCountries = ['us', 'gb'],
  country = 'us',
  ...props
}) => {
  const [selectedCountry, setSelectedCountry] = useState('');
  const [placeholder, setPlaceholder] = useState(
    PHONE_INPUT_PLACEHOLDERS[String(country).toUpperCase() as keyof typeof PHONE_INPUT_PLACEHOLDERS]
  );

  const { setFieldValue } = useFormikContext();

  const [field, meta, helpers] = useField(name);

  const { setError } = helpers;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const error = meta.error as any;
  const isError =
    (isRequired && meta.touched && !meta.value) || (isRequired && meta.touched && !!error);

  const handleOnChange = (
    value: string,
    data: CountryData,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { format, countryCode, dialCode } = data;

    if (selectedCountry !== countryCode) {
      setFieldValue(name, `+${dialCode}`);
      setError('');
    }

    setSelectedCountry(countryCode);
    setFieldValue('format', format);
    setPlaceholder(
      PHONE_INPUT_PLACEHOLDERS[
        (data as CountryData).countryCode.toUpperCase() as keyof typeof PHONE_INPUT_PLACEHOLDERS
      ]
    );

    if (event.type) {
      field.onChange(event);
    }
  };

  return (
    <InputWrapperStyled isError={isError}>
      {label && (
        <InputLabelStyled>
          {label} {isRequired && <StarStyled> *</StarStyled>}
        </InputLabelStyled>
      )}

      <PhoneInput
        {...props}
        {...field}
        placeholder={placeholder}
        onChange={handleOnChange}
        country={country}
        preferredCountries={preferredCountries}
        inputProps={{ name, required: isRequired }}
      />

      {isError && error && (
        <ErrorMessageStyled>
          <FormattedMessage id={error.id} defaultMessage={error.defaultMessage} />
        </ErrorMessageStyled>
      )}
    </InputWrapperStyled>
  );
};

export default FormikPhoneInput;
